export enum TrackingEvent {
  SelectProperty = `Select Property`,
  SelectPropertiesDropdownOption = `Select properties dropdown option`,
  ExpandedSection = `Expanded Section`,
  CreateInlineCohort = `Created Inline Cohort`,
  EditInlineCohorts = `Edit Inline Cohort`,
  SaveInlineCohorts = `Save Inline Cohort`,
  OpenInlineCohortsModal = `Opened Inline Cohorts Modal`,
  OpenPropertiesDropDown = `Opened Properties DropDown`,
  CreateCustomProperty = `Custom Property - create`,
  EditCustomProperty = `Custom Property - edit`,
  ShowHiddenEntity = `[Lexicon] Show Hidden Entities`,
}
